module.exports = __webpack_public_path__ + "media/ferulic-medium.067b9121.mp4";